import React from 'react';
import PrimaryButton from '../PrimaryButton/PrimaryButton';

interface HomeAdBannerProps {
  title?: string;
  imageUrl: string;
  primaryAction: { label: string; onClick: () => void };
  disabled?: boolean;
}

const HomeAdBanner: React.FC<HomeAdBannerProps> = ({
  title,
  imageUrl,
  primaryAction,
  disabled = false,
}) => {
  return (
    <div
      className="relative mx-auto flex min-h-[280px] items-end justify-end overflow-hidden rounded-lg p-8 text-white shadow-md md:min-h-[400px]"
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute inset-0 z-0 bg-black/30 md:bg-black/15" />
      <div className="relative z-10 flex max-w-md flex-col items-end text-right">
        {title ? (
          <h2 className="mb-4 text-3xl font-black drop-shadow md:text-5xl">{title}</h2>
        ) : null}
        <PrimaryButton text={primaryAction.label} fn={primaryAction.onClick} isDisabled={disabled} />
      </div>
    </div>
  );
};

export default HomeAdBanner;
